import * as types from '../mutation-types'
import api from '../api'
import Vue from 'vue'

const _isFalsy = (val) => _.isNil(val) || _.isEmpty(val) || val == 0 || val === false
const _isValid = (val) => !_isFalsy(val)

const requestCancel = {
  token: Vue.axios.CancelToken,
  source: null
}

const demands = {
  namespaced: true,

  state: {
    forms:[],
    demands:[],
    users_infos:[],
    payment_methods:[],
    current_demands:[],
    candidates:[],
    orders:[],
    sortParams:{
      created_at:'asc',
      updated_at:'asc',
    },
    filters: {
      // grouped_by:'created_at',
      // ordered_by:'desc',
      statut:'pending',
      // status:[{id:0, text:"En attente", data:"pending"} , {id:1, text:"Validée", data:"validated"}, {id:2, text:"Refusée", data:"refused"}],
    },
    expected_documents: [],
    current_treating_demand:{
      demand:null,
      customer:null,
      optional_params:null,
      order_id:null,
      order:null,
      documents:null,
    },
    cancel_authorizations:null,
    capture_authorizations:null,
    errors: [],
    requestCancel
  },

  mutations: {

    [types.DEMANDS_RECEIVED](state, payload) {
      state.demands = payload
    },

    [types.DEMANDS_FILTERS_UPDATED](state, payload) {
      state.filters = payload
      state.demands = []
    },

    [types.DEMANDS_CANDIDATES](state, payload) {
      state.candidates = []
      state.candidates = payload
    },

    [types.DEMANDS_VALIDATION_REQUESTS] (state, payload) {
      state.demands = payload.validation_requests
    },

    [types.VALIDATION_REQUEST_EXPECTED_DOCUMENTS_FETCHED](state, payload) {
      state.expected_documents = payload.expected_documents
    },

    [types.DEMANDS_VALIDATION_TREATMENT_FORM] (state, payload) {
      // Conservation de cette logique le temps de s'assurer qu'il n'y a pas de regression
      // Je ne vois pourtant pas pourquoi on a eu besoin d'utiliser un array pour stocker le treatment form ???
      
      // if (_.isNil(_.find(state.forms, (frms) => frms.main_request.request.id == payload.main_request.request.id)))
      //   state.forms.push(payload)
      
      state.forms = []
      state.forms.push(payload)
    },

    [types.DEMANDS_VALIDATED](state, payload) {
      console.warn('DEMAND_VALIDATED')
    },

    [types.DEMANDS_REFUSED](state, payload) {
      console.warn('DEMANDS_REFUSED')
    },

    [types.DEMANDS_SINGLE_VALIDATION_REQUESTS] (state, payload) {
      state.current_demands = [payload.validation_request]
      // if (_.find(state.current_demands, (demand) => demand.id == payload.validation_request.id) == undefined)
      //   state.current_demands.push(payload.validation_request)
    },

    [types.DEMANDS_SORT_UPDATED](state, payload) {
      state.sortParams[payload.field] = payload.direction
    },

    [types.DEMANDS_USER_INFOS](state, payload) {
      if (_.isNil(_.find(state.users_infos, (uis) => uis.id == payload.user.id)))
        state.users_infos.push(payload.user)
    },

    [types.DEMANDS_PAYMENTS_METHODS](state, payload) {
      state.payment_methods = payload.payment_methods
    },

    [types.DEMANDS_FLUSH_STATE](state, payload) {
      state.payment_methods = []
      state.demands = []
      state.forms = []
    },

    [types.DEMANDS_MAKE_PAYMENT](state, payload) {
    },

    [types.DEMANDS_ATTACH_SAP_CUSTOMER](state, payload) {
    },

    [types.DEMANDS_ORDER_OPTIONS] (state, payload) {
      state.orders = _.filter(state.orders, (order) => order.id != payload.order.id)
      if (undefined == _.find(state.orders, (order) => order.id == payload.order.id))
        state.orders.push(payload.order)
    },

    [types.DEMANDS_ORDER_OPTIONS_RESET](state, payload) {
      state.order = []
    },

    [types.ORDER_CANCEL_AUTORIZATION] (state, payload) {
      state.cancel_authorizations = payload
    },
    
    [types.ORDER_CAPTURE_AUTORIZATION] (state, payload) {
      state.capture_authorizations = payload
    },

    [types.DEMAND_OPTIONAL_PARAMS_SET] (state, payload) {
      state.current_treating_demand.optional_params = payload
    },

    [types.DEMAND_CURRENT_TREATING_DEMAND_SET](state, payload) {
      state.current_treating_demand.demand = payload
    },

    [types.REQUEST_TOKEN_SOURCE_CHANGED](state, source) {
        state.requestCancel.source = source
    }

  },

  actions: {
    getCandidates({ commit, state, getters }, params) {
      return api.searchCustomer(params)
                .then((response) => {
                      commit(types.DEMANDS_CANDIDATES, response.data.customers)
                })
                .catch((error) => console.warn(error))
    },

    getValidationRequests({commit, state, getters}, params) {
      if (params !== undefined && params !== null && String(params.page) == String(NaN))
        params.page = 1
      else if (params == undefined) {
        const params = { page: 1 }
      }

      if (!_.isNull(state.requestCancel.source))
          state.requestCancel.source.cancel()

      const token = state.requestCancel.token,
          source = token.source(),
          cancelToken = source.token
      commit(types.REQUEST_TOKEN_SOURCE_CHANGED, source)

      let p = {
        agency_id: state.filters.agency_id, 
        search: state.filters.statut, 
        group: state.filters.group,
        per_page: 25, 
        page: params.page, 
        with:params.with
      }

      return api.getValidationRequests(p, cancelToken)
                .then((response) => {
                  commit (types.DEMANDS_VALIDATION_REQUESTS, response.data)
                })
    },

    getValidationRequestById({ commit, state, getters }, id) {
      return api.getValidationRequestsById(id)
        .then((response) => {
          commit(types.DEMANDS_SINGLE_VALIDATION_REQUESTS, response.data)
        })
    },

    getUserInfos({ commit, state }, user_id) {
      if (_.isNil(_.find(state.users_infos, (uis) => uis.id == user_id)))
        return api.getUser(user_id)
          .then((response) => {
            commit(types.DEMANDS_USER_INFOS, response.data)
          })
          .catch((error) => console.warn(error))
    },

    validationRequestTreatmentForm({ commit, state, getters }, validation_request_id) {
      if (_.isNil(_.find(state.forms, (frms) => frms.main_request.request.id == validation_request_id)))
        return this.dispatch('demands/forcedValidationRequestTreatmentForm', validation_request_id)
    },

    forcedValidationRequestTreatmentForm({commit, state, getters}, validation_request_id) {
      return api.getValidationRequestsTreatmentForm(validation_request_id)
        .then((response) => {
          commit (types.DEMANDS_VALIDATION_TREATMENT_FORM, response.data)
        })
        .catch((errors) => console.warn(errors))
    },

    valideValidation({ commit, state, getters }, params) {
      params.validation_override = 1
      return api.valideValidationRequests(params.validation_request_id, params.others)
                .then((response) => {
                  commit (types.DEMANDS_VALIDATED, response.data)
                })

    },

    refuseValidation({ commit, state, getters, actions }, validation_request_id) {
      return api.refuseValidationRequests(validation_request_id)
                .then((response) => {
                  commit (types.DEMANDS_REFUSED, response.data)
                })

    },

    cleanCandidates({ commit }) {
      commit(types.DEMANDS_CANDIDATES, [])
    },

    updateFilter({ commit, dispatch }, filters) {
      commit(types.DEMANDS_FILTERS_UPDATED, filters)
    },

    updateSortParams({ commit, state }, datas) {
      commit(types.DEMANDS_SORT_UPDATED, datas)
      var tmp = _.sortBy(state.demands, datas.field)
      if (datas.direction == 'desc')
        commit(types.DEMANDS_RECEIVED, _.reverse(tmp))
      else {
        commit(types.DEMANDS_RECEIVED, tmp)
      }
    },

    getPaymentMethods({ commit, state }, order_id) {
      if (order_id)
        return api.getPaymentMethods(order_id)
          .then((response) => {
            commit(types.DEMANDS_PAYMENTS_METHODS, response.data)
          })
          .catch((error) => { console.warn(error) })
    },

    flush({ commit, state }) {
      commit(types.DEMANDS_FLUSH_STATE, {})
    },

    attachSAPCustomer({ commit, state }, params) {
      return api.attachSapCustomer(params.order_id, params.sap_customer)
        .then((response) => commit(types.DEMANDS_ATTACH_SAP_CUSTOMER, response.data))
        .catch((error) => console.warn(error))
    },

    make_payment({ commit, state }, params) {
      return api.makePayment(params)
        .then((response) => commit(types.DEMANDS_MAKE_PAYMENT, response.data))
    },

    get_options({ commit, state }, params) {
      return api.get_order_with_options(params)
        .then((response) => commit(types.DEMANDS_ORDER_OPTIONS, response.data))
        .catch((error) => console.warn(error))
    },

    fetchExpectedDocuments({ commit }, validationRequestId) {
      const params = {}

      return api.getValidationRequestExpectedDocuments(validationRequestId, params)
        .then(response => commit(types.VALIDATION_REQUEST_EXPECTED_DOCUMENTS_FETCHED, response.data))
    },

    cancelAuthorizations({ commit, state }, params) {
      return api.cancel_authorizations(params)
        .then(response => commit(types.ORDER_CANCEL_AUTORIZATION, {order_id: params, response: response}))
    },

    captureAutorizations({commit}, params) {
      return api.capture_autorizations(params)
        .then(response => commit(types.ORDER_CAPTURE_AUTORIZATION, {order_id: params, response: response}))
    },

    clearError({state}, params) {
      state.errors = []
    },

    resetDemandsOrders({commit} ) {
      commit(types.DEMANDS_ORDER_OPTIONS_RESET, {})
    },

    set_available_idxs({commit, rootState}, arr) {
      rootState.tabs.treatmentDemandTabs.available_tabs_indexes = arr
    },

    set_numerotation({commit, rootState}, flag) {
      rootState.tabs.treatmentDemandTabs.numeroted_tab_header = flag
    },

    store_optional_params({commit}, params) {
      commit(types.DEMAND_OPTIONAL_PARAMS_SET, params)
    },

    set_current_treating_demand ({commit}, params) {
      commit(types.DEMAND_CURRENT_TREATING_DEMAND_SET, params)
    },

    setActiveTab({rootState}, idx_tab)
    {
        rootState.tabs.treatmentDemandTabs.activeTab = idx_tab
    },
  },

  getters: {
    get_demands(state) {
      return (state.demands.data)
    },

    get_candidates(state) {
      return state.candidates
    },

    get_filters(state) {
      return state.filters
    },

    get_treatment_forms(state) {
      return state.forms
    },

    get_payment_methods(state) {
      return state.payment_methods
    },


  },

}

export default demands



// WEBPACK FOOTER //
// ./client/store/modules/demands.js